import { render, staticRenderFns } from "./_BookingDetails.vue?vue&type=template&id=f868b762&scoped=true&"
import script from "./_BookingDetails.vue?vue&type=script&lang=js&"
export * from "./_BookingDetails.vue?vue&type=script&lang=js&"
import style0 from "./_BookingDetails.vue?vue&type=style&index=0&id=f868b762&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f868b762",
  null
  
)

export default component.exports